export default __webpack_public_path__ + "static/media/130px-Headshot.fcc4d52c.png";